import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UserService } from '../../services/user/user.service';
import { Constants } from '../../constants/constants';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { NgSignaturePadOptions, SignaturePadComponent } from '@almothafar/angular-signature-pad';
import { JobService } from 'src/app/services/job/job.service';


@Component({
  selector: 'modal-signature',
  templateUrl: './modal-signature.component.html',
  styleUrls: ['./modal-signature.component.scss'],
})
export class ModalSignatureComponent implements OnInit 
{
  @ViewChild('signature')
  public signaturePad: SignaturePadComponent;

  signee: string;

  public signaturePadOptions: NgSignaturePadOptions = { // passed through to szimek/signature_pad constructor
    minWidth: 5,
    canvasWidth: 600,
    canvasHeight: 300,
    backgroundColor: 'white'
  };


  constructor(public appearanceService: AppearanceService, private jobService: JobService,
    public userService: UserService, private modalController: ModalController) { }


  ngOnInit() 
  {

  }


  ionViewWillEnter() 
  {

  }


  ionViewDidEnter()
  {
    this.signaturePad.set('minWidth', 5); // set szimek/signature_pad options at runtime
    this.signaturePad.set('backgroundColor', 'rgba(0,0,0,0)');
    this.signaturePad.clear();
  }

  
  drawComplete(event: MouseEvent | Touch) {
    // will be notified of szimek/signature_pad's onEnd event
   // console.log('Completed drawing', event);
   // console.log(this.signaturePad.toDataURL());
  }

  drawStart(event: MouseEvent | Touch) {
    // will be notified of szimek/signature_pad's onBegin event
    //console.log('Start drawing', event);
  }

  closeModal(signed = null) 
  {
    this.modalController.dismiss({ signed: signed }, null, 'SignatureModal');
  }

  signatureDone()
  {
    var pngBase64 = this.getCroppedCanvasImage();
    var returnData = { signature: pngBase64 };
    this.modalController.dismiss(returnData, null, 'SignatureModal');
  }


  getCroppedCanvasImage() 
  {
    let canvas: HTMLCanvasElement = document.getElementsByTagName("canvas")[0];
    let croppedCanvas:HTMLCanvasElement = document.createElement('canvas');
    let croppedCtx:CanvasRenderingContext2D = croppedCanvas.getContext("2d");

    croppedCanvas.width = canvas.width;
    croppedCanvas.height = canvas.height;
    croppedCtx.drawImage(canvas, 0, 0);

    let w = croppedCanvas.width;
    let h = croppedCanvas.height;
    let pix = {x:[], y:[]};
    let imageData = croppedCtx.getImageData(0,0,w,h);
    let index = 0;

    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        index = (y * w + x) * 4;
        if (imageData.data[index+3] > 0) {
          pix.x.push(x);
          pix.y.push(y);
        }
      }
    }

    pix.x.sort((a,b) => a-b);
    pix.y.sort((a,b) => a-b);
    let n = pix.x.length-1;

    w = pix.x[n] - pix.x[0];
    h = pix.y[n] - pix.y[0];
    var cut = croppedCtx.getImageData(pix.x[0], pix.y[0], w, h);

    croppedCanvas.width = w;
    croppedCanvas.height = h;
    croppedCtx.putImageData(cut, 0, 0);

    return croppedCanvas.toDataURL();
  }
}